// extracted by mini-css-extract-plugin
module.exports = {"testReportContainer":"styles__testReportContainer--3XZ5b","red":"styles__red--LmQDi","green":"styles__green--1Zs_M"};